<template>
  <div class="header" id="header">
    <div class="container">
      <div class="flex-row">        
        <span class="btn-default btn-user-profile" @click="profileVisible=!profileVisible" >
          <span class="user-circle" v-bind:class="{ 'user-circle-active': profileVisible }">
            <font-awesome-icon icon="user-circle"/>
          </span>
          <span class="user-caret" v-bind:class="{ 'user-caret-active': profileVisible }">
          <font-awesome-icon icon="caret-down"/>
          </span>
          <transition name="slide-in">
            <div class="profile-dropdown dropdown" v-if="profileVisible" v-click-outside="closeProfile">
              <span class="caret">
                <font-awesome-icon icon="caret-up"/> 
              </span>
              <div class="name" v-if="logedIn">{{ userName }}</div>
              <div class="action" v-if="!logedIn">
                <button class="btn-dropdown" @click="showLogin()">
                  <font-awesome-icon icon="sign-in-alt"/> &nbsp;
                  Anmelden
                </button>
              </div>
              <div class="action" v-if="!logedIn">
                <button class="btn-dropdown" @click="showRegister()">
                  <font-awesome-icon icon="user"/> &nbsp;
                  Registrieren
                </button>
              </div>
              <div class="action">
                <a href="https://nextcloud.ff-pfaffenhofen.de" class="btn-dropdown">
                  <font-awesome-icon icon="cloud" class="cloud" /> &nbsp;
                  <span class="cloud-text">Intern</span>
                </a>
              </div>
              <!--  <div class="action" v-if="logedIn">
                <a class="btn-dropdown" href="#/devices">
                  <font-awesome-icon icon="qrcode"/> &nbsp;
                  Geräte
                </a>
              </div>  -->
              <div class="action" v-if="logedIn">
                <button class="btn-dropdown" @click="showLogout()">
                  <font-awesome-icon icon="sign-out-alt"/> &nbsp;
                  Abmelden
                </button>
              </div>
              <div class="action" v-if="logedIn">
                <button class="btn-dropdown btn-disabled" disabled> 
                  <font-awesome-icon icon="lock"/> &nbsp;
                  Passwort ändern
                </button>
              </div>
            </div>
          </transition>
        </span>

      </div>
      <span class="small-nav">
        <button class="btn-default" @click="overlayVisible=true">
          <font-awesome-icon icon="bars"/>
        </button>
      </span>
      <span class="big-nav" v-if="showMenu" v-bind:class="{ 'menu-active': menuVisible }">
        <button class="btn-default" @click="menuVisible=!menuVisible">
          <font-awesome-icon icon="bars" class="menu-icon" v-bind:class="{ 'menu-active': menuVisible }"/>
        </button>
        <transition name="slide-in">
            <div class="menu-dropdown dropdown" v-if="menuVisible" v-click-outside="closeMenu">
              <span class="caret">
                <font-awesome-icon icon="caret-up"/> 
              </span>
               <div class="name">Navigation</div>

              <div class="action">
                <router-link to="/" class="btn-dropdown">Start</router-link>
              </div>
              <div class="action">
                <router-link to="einsatz" class="btn-dropdown">Einsätze</router-link>
              </div>
              <div class="action">
                <router-link to="aktuelles" class="btn-dropdown">Aktuelles</router-link>
              </div>
              <div class="action">
                <router-link to="/fahrzeug" class="btn-dropdown">Fahrzeuge</router-link>
              </div>
              <div class="action">
                <router-link to="group" class="btn-dropdown">Mannschaft</router-link>
              </div>
              <div class="action">
                <router-link to="jugend" class="btn-dropdown">Jugendgruppe</router-link>
              </div>
              <div class="action">
                <router-link to="standort" class="btn-dropdown">Standort</router-link>
              </div>
               <div class="action">
                <router-link to="/#contact" class="btn-dropdown" v-scroll-to="{ element: '#contact', duration: 500 }">Kontakt</router-link>
              </div>
            </div>
          </transition>
      </span>
      <span class="header-title">{{headerTitle}}</span>


      <transition name="slide-in">
        <div class="small-overlay" v-if="overlayVisible">
          <button class="btn-default btn-close" @click="overlayVisible=false">
            <font-awesome-icon icon="times"/>
          </button>
          <div class="overlay-content">
            <h2 class="heading">Freiwillige Feuerwehr</h2>
            <h1 class="heading">Pfaffenhofen</h1>
            <div class="seperator"></div>
            <router-link class="link" to="/">Start</router-link>
            <router-link class="link" to="aktuelles">Aktuelles</router-link>
            <router-link class="link" to="einsatz">Einsätze</router-link>
            <router-link class="link" to="fahrzeug">Fahrzeuge</router-link>
            <router-link class="link" to="group">Mannschaft</router-link>
            <router-link class="link" to="jugend">Jugendgruppe</router-link>
            <router-link class="link" to="standort">Standort</router-link>
            <router-link to="/#contact" class="link" v-scroll-to="{ element: '#contact', duration: 500 }">Kontakt</router-link>
          </div>
        </div>
      </transition>
    </div>

    <modal name="login-modal" :pivotY=0.2 height="auto" :adaptive="true">
      <div class="login-modal modal">
        <h1>Anmelden</h1>
        <p>
          Melden Sie sich an, um Inhalte ändern zu können. 
        </p>
        <p class="input-error" v-if="loginData.failedLogin">Anmeldung nicht möglich. Überprüfen Sie Ihre Email und Passwort.</p>
        <p class="input-error" v-if="loginData.failedActivation">Account noch nicht aktiviert. Aktivierungslink wurde an Ihre Email gesendet.</p>
        <form @submit.prevent="login()">
          <label for="email">Email <span class="required">*</span></label>
          <div class="input-row">
            <span class="input-icon">
              <font-awesome-icon icon="at"/>
            </span>
            <input type="email" placeholder="Feuerwehr Email" name="email" v-model="loginData.email"/>
          </div>
          <p class="input-error" v-if="loginData.errorEmail">Feld muss ansgefüllt werden.</p> 
          <label for="password">Passwort  <span class="required">*</span></label>
          <div class="input-row">
            <span class="input-icon">
              <font-awesome-icon icon="lock"/>
            </span>
            <input type="password" placeholder="Passwort" name="password" v-model="loginData.password"/>
          </div>
          <p class="input-error" v-if="loginData.errorPassword">Feld muss ansgefüllt werden.</p> 
          <div class="footer">
            <button class="btn-primary" type="submit">
              <font-awesome-icon icon="sign-in-alt" />
              Anmelden</button>
            <button class="btn-default" @click="hideLogin()">Abbrechen</button>
          </div>
        </form>
      </div>
    </modal>

    <modal name="register-modal" :pivotY=0.2 height="auto" :adaptive="true"> 
      <div class="register-modal modal">
        <h1>Registrieren</h1>
        <p v-if="registerData.registerSuccess">
          Daten gesendet, Registrieren erfolgreich sobald der Account freigeschalten wurde. 
        </p>
        <p v-else>
          Beachten Sie, dass nur Mitglieder der Freiwilligen Feuerwehr Pfaffenhofen die Möglichkeit haben, sich zu registrieren. <br>
          <b>Hinweis: </b> Der Account muss manuell vom Administrator freigechaltet werden. 
        </p>
        <p class="input-error" v-if="registerData.accountExists">Account exisitert bereits.</p>
        <form @submit.prevent="register()" v-if="!registerData.registerSuccess">
          <label for="email">Email <span class="required">*</span></label>
          <div class="input-row">
            <span class="input-icon">
              <font-awesome-icon icon="at"/>
            </span>
            <input type="email" placeholder="Feuerwehr Email" name="email" v-model="registerData.email"/>
          </div>
          <p class="input-error" v-if="registerData.errorEmail">Feld muss ansgefüllt werden.</p> 
          <p class="input-error" v-if="registerData.wrongEmail">Bitte Feuerwehr Email verwenden.</p>
          <label for="email">Name <span class="required">*</span></label>
          <div class="input-row">
            <span class="input-icon">
              <font-awesome-icon icon="user"/>
            </span>
            <input type="text" placeholder="Vorname Nachname" name="name" v-model="registerData.name"/>
          </div>
          <p class="input-error" v-if="registerData.errorName">Feld muss ansgefüllt werden.</p> 
          <label for="password">Passwort  <span class="required">*</span></label>
          <div class="input-row">
            <span class="input-icon">
              <font-awesome-icon icon="lock"/>
            </span>
            <input type="password" placeholder="Passwort" name="password0" v-model="registerData.password0" @change="comparePasswords()"/>
          </div>
          <p class="input-error" v-if="registerData.errorPassword0">Feld muss ansgefüllt werden.</p> 
          <label for="password">Passwort wiederholden<span class="required">*</span></label>
          <div class="input-row">
            <span class="input-icon">
              <font-awesome-icon icon="lock"/>
            </span>
            <input type="password" placeholder="Passwort" name="password1" v-model="registerData.password1" @change="comparePasswords()"/>
          </div>
          <p class="input-error" v-if="registerData.errorPassword1">Feld muss ansgefüllt werden.</p>  
          <p class="input-error" v-if="registerData.wrongPassword">Passwörter stimmen nicht überein.</p> 
          <p class="input-error" v-if="registerData.shortPassword">Aus Sicherheitsgründen sollten Passwörter immer länger als 6 Zeichen sein.</p> 
          <div class="footer">
            <button class="btn-primary" type="submit">
              <font-awesome-icon icon="sign-out-alt" />
              Registrieren</button>
            <button class="btn-default" @click="hideRegister()">Abbrechen</button>
          </div>
        </form>
        <div class="footer" v-if="registerData.registerSuccess">
            <button class="btn-primary" @click="hideRegister()">
              <font-awesome-icon icon="sign-out-alt" />
              Okey
              </button>
          </div>
      </div>
    </modal>

     <modal name="logout-modal" :pivotY=0.2 height="auto" :adaptive="true">
      <div class="logout-modal modal">
        <h1>Abmelden</h1>
        <p>Sie sind dabei sich abzumelden. Fortfahren?</p>
        <div class="footer">
          <button class="btn-primary" @click="logout()">
            <font-awesome-icon icon="sign-out-alt" />
            Abmelden</button>
          <button class="btn-default" @click="hideLogout()">Abbrechen</button>
        </div>
      </div>
    </modal>

  </div>
</template>

<script>
import { EventBus } from '../event-bus.js'
import dropdown from 'vue-my-dropdown'
import ClickOutside from 'vue-click-outside'

export default {
  name: 'Header',
  components: {
    dropdown
  },
  directives: {
    ClickOutside
  },
  data: () => {
    return {
      profileVisible: false,
      overlayVisible: false,
      menuVisible: false,
      showMenu: false,
      logedIn: false,
      userName: "",
      userID: "",
      loginData: {
        keep: false,
        errorEmail: false,
        errorPassword: false,
        failedLogin: false,
        failedActivation: false
      },
      registerData: {
        email: "",
        password0: "",
        errorEmail: false,
        wrongEmail: false,
        errorName: false,
        errorPassword0: false,
        errorPassword1: false,
        wrongPassword: false,
        shortPassword: false,
        registerSuccess: false,
        accountExists: false
      }
    }
  },
  beforeMount: function() {
    if(this.$session.get('loginTime')) {

      let loginTime = this.$session.get('loginTime');
      let elapsed = Date.now() - loginTime

      // loged in for 2 hour max
      const timeout = 1000 * 60 * 60 * 2
      if(elapsed < timeout) {
        // reset the loginTime
        this.$session.set('loginTime', Date.now())
      } else {
        // trigger logout
        this.$session.remove('userID')
        this.$session.remove('userName')
        this.$session.remove('loginTime')

        EventBus.$emit('logout')
        
      }
    }
  },
  mounted: function() {
    this.handleScroll()
    this.userName = this.$session.get('userName')
    if (this.userName) {
      this.shortName = this.userName.split(" ").pop()
    }
    this.userID = this.$session.get('userID')
    if(this.$session.get('userID')) {
      this.logedIn = true
    }

    this.popupItem = this.$el

    
  },
  props: {
    'menuAt': Number,
    'headerTitle': String
  },
  methods: {
    closeProfile() {
      this.profileVisible = false
    },
    closeMenu() {
      this.showMenu = window.pageYOffset >= this.menuAt
      this.menuVisible = false
    },
    showLogin() {
      this.$modal.show('login-modal')
      
      this.loginData.errorEmail = false
      this.loginData.errorPassword = false
      this.loginData.failedLogin = false
      this.loginData.failedActivation = false
    },
    showRegister() {
      this.$modal.show('register-modal')
      
      this.registerData.errorEmail = false
      this.registerData.errorName = false
      this.registerData.errorPassword0 = false
      this.registerData.errorPassword1 = false
      this.registerData.wrongEmail = false
      this.registerData.wrongPassword = false
      this.registerData.accountExists = false
    },
    showLogout() {
      this.$modal.show('logout-modal')
    },
    hideLogin() {
      this.$modal.hide('login-modal')
    },
    hideRegister() {
      this.$modal.hide('register-modal')
    },
    hideLogout() {
      this.$modal.hide('logout-modal')
    },
    login() {

      let error = false
      this.loginData.errorEmail = false
      this.loginData.errorPassword = false
      this.loginData.failedLogin = false
      this.loginData.failedActivation = false

      if(!this.loginData.email) {
        error = true
        this.loginData.errorEmail = true
      }
      if(!this.loginData.password) {
        error = true
        this.loginData.errorPassword = true 
      }

      if(error) return;

      this.axios.post('https://ff-pfaffenhofen.de/api/v1/user/authentificate', {
          email: this.loginData.email,
          password: this.loginData.password
        }, {withCredentials: true})
      .then((response) => {
        const data = response.data

        if(!data.is_activated) {
          this.logedIn.failedActivation = true
          return
        }

        if(data.is_correct) {
          this.$session.start()
          this.$session.set('userID', data.user_id)
          this.$session.set('userName', data.user_name)
          this.$session.set('loginTime', Date.now())

          this.userName = data.user_name
          this.logedIn = true
          this.$modal.hide('login-modal')
          
          EventBus.$emit('login', data.user_id)

        } else {
          this.loginData.failedLogin = true
        }

      })
      
      
    },
    logout() {
      this.$modal.hide('logout-modal');
      this.logedIn = false;
      this.userID = ""
      this.userName = ""
      this.loginData.failedLogin = false

      this.$session.remove('userID')
      this.$session.remove('userName')
      this.$session.remove('loginTime')

      EventBus.$emit('logout')
    },
    register() {

      let error = false
      this.registerData.errorEmail = false
      this.registerData.errorName = false
      this.registerData.errorPassword0 = false
      this.registerData.errorPassword1 = false
      this.registerData.wrongEmail = false
      this.registerData.wrongPassword = false
      this.registerData.accountExists = false

      if(!this.registerData.email) {
        error = true
        this.registerData.errorEmail = true
      }
      if(!this.registerData.name) {
        error = true
        this.registerData.errorName = true
      }
      if(!this.registerData.password0) {
        error = true
        this.registerData.errorPassword0 = true
      }
      if(!this.registerData.password1) {
        error = true
        this.registerData.errorPassword1 = true
      }

      if(error) {
        return
      }

      if(!this.registerData.email.endsWith('@ff-pfaffenhofen.de')) {
        error = true
        this.registerData.wrongEmail = true
      }
      if(this.registerData.password0.length < 6) {
        error = true
        this.registerData.shortPassword = true
      }

      error = error || this.registerData.wrongPassword
      if(error) {
        return
      }

      this.axios.post('https://ff-pfaffenhofen.de/api/v1/user/create', {
          email: this.registerData.email,
          password: this.registerData.password0,
          name: this.registerData.name
        }, {withCredentials: true})
      .then((response) => {
        const data = response.data

        if(data.already_exists) {
          this.registerData.accountExists = true
          return
        }

        this.registerData.registerSuccess = true
        
      })
    },
    comparePasswords() {
      this.registerData.shortPassword = false
      this.registerData.wrongPassword = false
      if(this.registerData.password0 && this.registerData.password1) {
        if(this.registerData.password0 != this.registerData.password1) {
          this.registerData.wrongPassword = true
        }
      }
    },
    handleScroll() {
        this.showMenu = window.pageYOffset >= this.menuAt || this.menuVisible
    }
  },
  created() {
    window.addEventListener('scroll', this.handleScroll)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../styles/theme.scss";

.header {
    background: $light-0;
    box-shadow: $shadow-light;
    position: fixed;
    top: 0;
    left: 0;
    height: 55px;
    width: 100%;
    z-index: 20;
}

.container {
  position: relative;
  padding: 0;
}

.flex-row {
  display: flex;
  flex-direction: row-reverse;
  height: 55px;
  margin-right: 20px;

  .btn-default {
    color: $dark;
  }
}

.small-nav {
  position: absolute;
  top: 10px;
  margin-left: 20px;
  z-index: 1;
  opacity: 0.5;

  .btn-default {
    font-size: 30px;

    @include desktop {
      display: none;
    }
  }
}

.cloud-text {
  margin-left: -3px;
}

.big-nav {
  position: absolute;
  z-index: 1;
  display: none;
  top: 0px;
  height: 100%;

  .btn-default {
    font-size: 26px;
    height: 100%;
  }
  @include desktop {
    display: block;  
  }

  .menu-icon {
    color: #787878;
  }

  .menu-active {
    color: $primary;
  }
}

.header-title {
  position: absolute;
  z-index: 1;
  top: 0px;
  left: 50px;
  height: 100%;

  text-transform: uppercase;
  color: #787878;

  display: none;
  font-size: 15px;
  font-weight: bold;

  @include desktop {
    display: grid;
    align-items: center;
  }
}

.small-overlay {
  position: fixed;
  top: 0px;
  left: 0;
  width: 100%;
  min-height: 100%;
  background: rgba(black, 0.98);
  z-index: 2;

  .btn-close {
    color: $light-0;
    opacity: 0.8;
    font-size: 36px;
    position: absolute;
    right: 40px;
    top: 40px;

    &:hover {
      opacity: 1;
    }
  }

  .overlay-content {
    padding-top: 80px;
    min-height: 100%;
    color: $light-0;
    text-align: center;
    overflow: auto;
  }

  .heading {
    color: $primary;
  }

  h1 {
    margin-top: -15px;
  }

  .link {
    color: $light-0;
    display: block;
    text-decoration: none;
    opacity: 0.8;
    font-size: 22px;
    margin-top: 20px;

    &:hover {
      opacity: 1;
    }
  }

  .seperator {
    margin: 10px 100px;
    height: 1px;
  }

  .large-seperator {
    margin: 10px 100px;
    height: 40px;
  }

}

.btn-user-profile {
  font-size: 14px;
  vertical-align: middle;
  position: relative;

  .user-circle {
    margin-right: 5px;
    font-size: 38px;
    vertical-align: middle;
    opacity: 0.5;
  }

  .user-caret {
    opacity: 0.5;
  }

  .user-circle-active {
    color: $primary;
    opacity: 1;
  }

  .user-caret-active {
    color: $primary;
    opacity: 1;
  }
}

.slide-in-enter-active, .slide-in-leave-active {
  transition: opacity .5s;
}
.slide-in-enter, .slide-in-leave-to {
  opacity: 0;
}

.menu-dropdown {
  left: 0px;
  margin-top: -5px;

  .caret {
    left: 10px;
    top: -20px;
  }
}

.profile-dropdown {
  right: -15px;
  margin-top: -5px;

  .caret {
    right: 10px;
    top: -20px;
  }
}

.dropdown {
  background: $dark;
  box-shadow: $shadow-light;
  width: 180px;
  position: absolute;
  z-index: 1;
  padding: 5px 0px 10px 0px;
  cursor: default;

  .caret {
    position: absolute;
    font-size: 30px;
    color: $dark;
  }

  .name {
    color: $light-0;
    font-weight: bold;
    font-size: 14px;
    overflow: hidden;
    padding: 8px 4px 8px 16px;
    opacity: 0.6;
    text-transform: uppercase;
  }

  .btn-dropdown {
    color: $light-0;
    font-weight: 400;
    font-size: 14px;
    background: none;
    border: none;
    outline: none;
    opacity: 0.8;
    cursor: pointer;
    width: 100%;
    text-align: left;
    padding: 8px 4px 8px 16px;

    &:hover {
      opacity: 1;
      background: lighten($dark, 7%);
    }
  }

  a {
    display: block;
    box-sizing: border-box;
    font-weight: 400 !important;
    text-decoration: none;
  }

  .btn-disabled {
    cursor: not-allowed;
  }
}

.modal {
  padding: 10px 30px;
  h1 {
    color: $primary;
  }
  p {
    color: lighten($dark, 40);
    font-size: 14px;
  }
  .footer {
    margin: 60px 0px 20px 0;
    display: flex;
    flex-direction: row-reverse;

    button  {
      font-size: 18px;
      font-weight: bold;
      margin-left: 12px;
    }
    .btn-default {
      color: lighten($dark, 40);

      &:hover {
        color: $dark;
      }
    }
    .btn-primary {
      color: desaturate($primary, 40);

      &:hover {
        color: $primary;
      }
    }
  }

  label {
    color: $dark;
    font-weight: bolder;

    .required {
      color: $primary;
    }
  }

  .input-row {
    margin: 4px 0px 12px 0px;
    display: flex;
  }

  .input-icon {
    background: lighten($gray, 36);
    color: lighten($dark, 12);
    padding: 8px 14px;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }

  input {
    flex-grow: 1;
    border: 0px;
    padding: 0px 12px;
    border: 1px solid #c4c4c4;
    font-size: 16px;

    &:focus, &:active {
      box-shadow: 0px 0px 4px $primary;
    }
  }

  .checkbox-text {
    font-size: 14px;
  }

  .input-error {
    color: $primary;
    margin-top: -6px;
  }
}

</style>
